import React, { useContext } from "react";

import { mdiPlusCircleOutline } from "@mdi/js";
import { Icon } from "@mdi/react";
import { useTranslation } from "react-i18next";

import { cn } from "@/src/lib/utils";

import MasterMediaContext from "../../../contexts/MasterMediaContext";
import { CHILD_CLASSIFICATIONS } from "../../content/Type";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";

import type { JSX } from "react";

import type { ChildClassification } from "../../../api/MediaAPI.types";
import type { MasterMediaContextValues } from "../../../contexts/MasterMediaContext";

interface CreateNewChildMediaProps {
  text?: string;
}

function CreateNewChildMedia({
  text = "",
}: CreateNewChildMediaProps): JSX.Element {
  const { t } = useTranslation("editor-content");
  const defaultText = t("addMedia");

  const { childMediaList, childClassificationList, addChildMedia } =
    useContext<MasterMediaContextValues>(MasterMediaContext);

  const handleClickMenu = (media: ChildClassification): void => {
    addChildMedia(media);
  };

  const dropdownMenuTriggerClassName = cn("hover:text-primary cursor-pointer");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className={dropdownMenuTriggerClassName}>
        <div className="mt-2 flex items-center gap-2">
          <div className="">{text || defaultText}</div>
          <Icon path={mdiPlusCircleOutline} size={0.8} />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuGroup>
          {childClassificationList?.map((media) => {
            const isDisabled =
              media.key === CHILD_CLASSIFICATIONS.MAIN &&
              Boolean(
                childMediaList?.find(
                  (childMedia) => childMedia.key === CHILD_CLASSIFICATIONS.MAIN,
                ),
              );
            return (
              <DropdownMenuItem
                key={media.key}
                className="cursor-pointer"
                disabled={isDisabled}
                onClick={() => handleClickMenu(media)}
              >
                {isDisabled
                  ? `${media.classificationLabel} (${t("alreadyExists")})`
                  : media.classificationLabel}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default CreateNewChildMedia;
